(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PublicController', PublicController);

    PublicController.$inject = ['$state', 'Principal'];

    function PublicController ($state, Principal) {
        var vm = this;

        vm.menuNavbarCollapsed = true;
        vm.searchValue = '';
        vm.toggleMenuNavbar = toggleMenuNavbar;
        vm.collapseMenuNavbar = collapseMenuNavbar;
        vm.scrollToTop = scrollToTop;
        vm.scrollToBottom = scrollToBottom;
        vm.search = search;
        vm.$state = $state;
        vm.isAuthenticated = Principal.isAuthenticated;

        $(window).scroll(function(){
            if ($(this).scrollTop() > 200) {
                /* show header sticky */
                $('#header-sticky').addClass('sticky');
                $('#header-sticky').removeClass('hidden');
                /* show social network sticky */
                $('#social-network-sticky').addClass('sticky');
                $('#social-network-sticky').removeClass('hidden');
                /* show scroll top top */
                $('#scroll-to-top').fadeIn();
                $('#scroll-to-bottom').fadeIn();

            } else {
                /* hide header sticky */
                $('#header-sticky').removeClass('sticky');
                $('#header-sticky').addClass('hidden');
                /* hide social network sticky */
                $('#social-network-sticky').removeClass('sticky');
                $('#social-network-sticky').addClass('hidden');

                /* hide scroll top top */
                $('#scroll-to-top').fadeOut();
                $('#scroll-to-bottom').fadeOut();
            }
        });

        function toggleMenuNavbar() {
            vm.menuNavbarCollapsed = !vm.menuNavbarCollapsed;
        }

        function collapseMenuNavbar() {
            vm.menuNavbarCollapsed = true;
        }

        function scrollToTop() {
            $('html, body').animate({ scrollTop: 0 }, 600);
        };

        function scrollToBottom() {
            $('html, body').animate({ scrollTop: $(document).height() }, "slow");
        };

        function search() {
            if (vm.searchValue !== undefined && vm.searchValue !== '') {
                window.location.replace('https://bj.scjn.gob.mx/busqueda?q=' + vm.searchValue);
            }
        }
    }
})();
